<template>
  <b-card>
    <h3 class="text-black ml-1">
      <strong>
        Insight Pengiriman
      </strong>
    </h3>
    <b-row class="mb-1 justify-content-end align-items-center">
      <b-col
        cols="7"
        md="4"
        style="text-align-last: right"
      >
        <BButton
          id="filter-shipping"
          variant="outline-secondary"
          class="rounded-lg"
          style="border: solid 1px #d8d6de !important; padding: 8px 14px;"
        >
          <div
            class="flex flex-row-reverse items-center justify-between h-full w-full gap-5"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/arrow-down-light.svg"
              alt="arrow-down"
            >
            <span class="leading-[1.2] text-sm">{{ filterShipment.shipping_name === null ? 'Semua Ekspedisi' : filterShipment.shipping_name }}</span>
          </div>
        </BButton>
        <BPopover
          ref="filter-shipping"
          target="filter-shipping"
          triggers="focus"
          placement="bottom"
          custom-class="wrapper-shipment"
        >
          <b-list-group>
            <b-list-group-item
              v-for="(item, index) in expeditionList"
              :key="index"
              class="cursor-pointer"
              :active="item.shipping_name === filterShipment.shipping_name"
              @click="filterByShipment(item)"
            >
              {{ item.shipping_name === null ? 'Semua Ekspedisi' : item.shipping_name }}
            </b-list-group-item>
          </b-list-group>
        </BPopover>
      </b-col>
      <b-col
        cols="5"
        sm="3"
        md="2"
        style="width: max-content;"
      >
        <flat-pickr
          v-model="filterMonth"
          class="custom-select"
          :config="flatpickrMonthly"
        />
      </b-col>
    </b-row>
    <b-row class="mx-0">
      <b-col
        md="6"
        lg="4"
        class="mb-1"
      >
        <CardCountSend
          :date="filterMonth"
          :shipping="filterShipment"
          @update="updateCount"
        />
      </b-col>
      <b-col
        md="6"
        lg="4"
        class="mb-1"
      >
        <CardOnSend
          :count-of-send="countOfSend"
          :date="filterMonth"
          :shipping="filterShipment"
        />
      </b-col>
      <b-col
        md="6"
        lg="4"
        class="mb-1"
      >
        <CardDelivery
          :count-of-send="countOfSend"
          :date="filterMonth"
          :shipping="filterShipment"
        />
      </b-col>
      <b-col
        md="6"
        lg="4"
        class="mb-1"
      >
        <CardRetur
          :count-of-send="countOfSend"
          :date="filterMonth"
          :shipping="filterShipment"
        />
      </b-col>
      <b-col
        md="6"
        lg="4"
        class="mb-1"
      >
        <CardBroken
          :count-of-send="countOfSend"
          :date="filterMonth"
          :shipping="filterShipment"
        />
      </b-col>
      <b-col
        md="6"
        lg="4"
        class="mb-1"
      >
        <CardLost
          :count-of-send="countOfSend"
          :date="filterMonth"
          :shipping="filterShipment"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { mapState } from 'vuex'
import { today, formatYmd } from '@/store/helpers'
import { configFlatPickr } from './component/config'
import CardCountSend from './component/CardCountSend.vue'
import CardOnSend from './component/CardOnSend.vue'
import CardDelivery from './component/CardDelivery.vue'
import CardRetur from './component/CardRetur.vue'
import CardBroken from './component/CardBroken.vue'
import CardLost from './component/CardLost.vue'

export default {
  components: {
    flatPickr,
    CardCountSend,
    CardOnSend,
    CardDelivery,
    CardRetur,
    CardBroken,
    CardLost,
  },
  data() {
    return {
      filterShipment: { id: '', image_path: '', shipping_name: null },
      expeditionList: [],
      filterMonth: formatYmd(today),
      flatpickrMonthly: configFlatPickr,
      countOfSend: null,
    }
  },
  computed: {
    ...mapState('filter', ['expedition']),
  },
  mounted() {
    if (this.expedition.length === 0) {
      this.$store.dispatch('filter/getUpdateExpedition')
    }
    this.expeditionList = [{ id: '', image_path: '', shipping_name: null }].concat(this.expedition)
  },
  methods: {
    filterByShipment(nextValue) {
      this.filterShipment = nextValue
      this.$refs['filter-shipping'].$emit('close')
    },
    updateCount(value) {
      if (value !== null) {
        this.countOfSend = value
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-flatpicker.scss';

.wrapper-shipment > .popover-body {
  padding: 0 !important;
  min-width: 200px;
}
</style>
